import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  type FetchTodayHistoryParams,
  fetchTodayHistory,
  type FetchOlderHistoryParams,
  fetchOlderHistory,
  type FetchSingleHistoryParams,
  fetchSingleHistory,
} from '../../api/fetchers/history/fetcher';

export const fetchTodayHistoryAction = createAsyncThunk(
  'history/fetchTodayHistory',
  (params: FetchTodayHistoryParams) => fetchTodayHistory(params)
);

export const fetchOlderHistoryAction = createAsyncThunk(
  'history/fetchOlderHistory',
  (params: FetchOlderHistoryParams) => fetchOlderHistory(params)
);

export const fetchSingleHistoryAction = createAsyncThunk(
  'history/fetchSingleHistory',
  (params: FetchSingleHistoryParams) => fetchSingleHistory(params)
);
